import instagramIcon from "@images/black-ic-inst.svg"
import linkedinIcon from "@images/black-ic-linkedin.svg"
import youtubeIcon from "@images/black-ic-youtube.svg"
import { LINKS } from "@constants"
import { GLOBAL_APPLICATION_EXTERNAL_LINKS } from "../../../../links"

export const IMPRESSIT_LOGO_ALT_TEXT = "Impressit logo";
export const IMPRESSIT_LOGO_ARIA_LABEL = "Impressit logo";
export const HEADER_FIRST_BUTTON_TEXT = "Startup Kit";
export const HEADER_SECOND_BUTTON_TEXT = "Contact us";
export const OPEN_BURGER_MENU_TEXT = "Menu";
export const CLOSE_BURGER_MENU_TEXT = "Close";

export const ARROW_UP_BACKGROUND_COLOR = "#252525";

export const SECOND_CATCH_UP_SECTION_TITLE = "Get in touch";
export const SECOND_CATCH_UP_SECTION_DESCRIPTION = "Complete contact form, and we will contact you within 24 hours";
export const SECOND_CATCH_UP_SECTION_CONTACT_US_BUTTON_TEXT = "Contact us";

export const COOKIE_POPUP_MESSAGE = "Our website uses cookies to ensure you receive the best experience possible."
export const COOKIE_POPUP_LINK_TEXT = "More info."
export const COOKIE_POPUP_SUBMIT_BUTTON_TEXT = "Got it!"

export const LAYOUT_BACKGROUND_COLOR = "#fff";

export const IMPRESSIT_SOCIAL_MEDIAS = [
  {
    icon: instagramIcon,
    ariaLabel: "Impressit Instagram",
    link: GLOBAL_APPLICATION_EXTERNAL_LINKS.INSTAGRAM,
  },
  {
    icon: linkedinIcon,
    ariaLabel: "Impressit Linkedin",
    link: GLOBAL_APPLICATION_EXTERNAL_LINKS.LINKEDIN,
  },
  {
    icon: youtubeIcon,
    ariaLabel: "Impressit Youtube",
    link: GLOBAL_APPLICATION_EXTERNAL_LINKS.YOUTUBE,
  },
];

export const FOOTER_NAVIGATIONAL_LINKS = [
  [
    { text: "Product development for startups", path: "/product-development" },
    { text: "Product development for enterprises", path: "/product-development" },
    { text: "Dedicated teams", path: "/dedicated-teams" },
    { text: "Contact us", path: "/contact-us" },
  ],
  [
    { text: "Blog", path: "/blog" },
    { text: "Careers",  path: "/careers" },
    { text: "Office", path: "/office" },
    { text: "About us", path: "/about" },
  ],
  [
    { text: "Privacy policy", path: "/privacy-policy" },
    { text: "GDPR",  path: "/gdpr" },
  ],
];

export const NAVIGATIONAL_ITEMS = [
  {
    items: [
      { title: "Services", navigationLinks: LINKS.services },
      { title: "Industry", navigationLinks: LINKS.industry },
    ],
  },
  {
    items: [
      { title: "Expertise", navigationLinks: LINKS.expertise },
      { title: "Company", navigationLinks: [...LINKS.company, ...LINKS.rest] },
    ],
  },
]
